import { InsuranceParameters, SetInsuranceParameters } from '../types';

export const closeModalOnClickOutside = (
  params: InsuranceParameters,
  setParams: SetInsuranceParameters,
  type: string
) => {
  setParams({
    ...params,
    modalsVisibility: {
      ...params.modalsVisibility,
      [type]: false,
    },
  });
};
